import { useQuery } from "@apollo/client";
import { Table, Button, Modal, Spin } from "antd";
import { useContext, useState } from "react";

import AssetTable from "./AssetTable";
import { FactoriesDocument } from "../../graphql/graphql";
import { CompanyProviderContext } from "../../providers/company/context";

interface FactoryRecord {
  key: string;
  name: string;
  location: string;
}

const FactoryTable = () => {
  const { currentCompany } = useContext(CompanyProviderContext);
  const { data: factoriesData, loading } = useQuery(FactoriesDocument, {
    skip: !currentCompany?.id,
    variables: { id: currentCompany?.id ?? "" },
  });

  const factories =
    factoriesData?.company.__typename === "QueryCompanySuccess"
      ? factoriesData.company.data.factories
      : [];

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedFactoryId, setSelectedFactoryId] = useState<string | null>(
    null,
  );

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin />
      </div>
    );

  const showModal = (id: string) => {
    setSelectedFactoryId(id);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedFactoryId(null);
  };

  const columns = [
    {
      title: "Factory",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Actions",
      key: "actions",
      render: (record: FactoryRecord) => (
        <Button
          type="primary"
          onClick={() => {
            showModal(record.key);
          }}
        >
          Show
        </Button>
      ),
    },
  ];

  const data: FactoryRecord[] = factories.map((factory) => ({
    key: factory.id,
    name: factory.name,
    location: factory.location,
  }));

  return (
    <>
      <Table
        bordered={false}
        columns={columns}
        dataSource={data}
        pagination={false}
        style={{ maxWidth: "80%", margin: "0 auto" }}
      />
      <Modal open={isModalVisible} onCancel={handleCancel} footer={null}>
        {selectedFactoryId && <AssetTable factoryId={selectedFactoryId} />}
      </Modal>
    </>
  );
};

export default FactoryTable;
